module.exports = __webpack_public_path__ + "img/document.4b56b0b3.png";